import { Grid, Box, Paper, Button } from "@mui/material";
import { isMobile } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import StatBox from "./StatBox";
import { useParams } from "react-router-dom";
import Countdown from "react-countdown";
import { useState } from "react";
import GenericModal from "../GenericModal";
import StandardActionButtons from "../StandarsActionButtons";
import RefreshIcon from "@mui/icons-material/Refresh";
import { examCategories } from "../../Utils/Constants";

export default function ExamHeader({
  total,
  remaining,
  correct,
  wrong,
  handleClick,
  handleQuestionaryReset,
  showSummary,
  setIsFinished,
  examCategory,
}: {
  total: number;
  remaining: number;
  correct: number;
  wrong: number;
  handleClick: () => void;
  handleQuestionaryReset: () => void;
  showSummary: boolean;
  setIsFinished: (isFinished: boolean) => void;
  examCategory?: string;
}) {
  const { examSetId } = useParams();
  const examMode = !examSetId;

  // Get exam duration from category or fall back to Config
  const categoryData =
    examCategories[examCategory as keyof typeof examCategories];
  const examDuration = (categoryData?.totalTime || 30) * 60 * 1000;

  const [endTime] = useState(() => Date.now() + examDuration);
  const [openQuestionaryWarning, setOpenQuestionaryWarning] = useState(false);
  // Renderer for custom timer display
  const renderer = ({ minutes, seconds }: any) => {
    // Format timer as MM:SS
    return (
      <span style={{ fontSize: "2rem" }}>
        {minutes.toString().padStart(2, "0")}:
        {seconds.toString().padStart(2, "0")}
      </span>
    );
  };

  return (
    <Box display="flex" justifyContent="center" mb={4}>
      <Paper
        elevation={1}
        sx={{
          borderRadius: 0,
          border: "1px solid #ccc",
          width: "100%",
          overflow: "hidden",
          display: isMobile() ? "block" : "flex",
          justifyContent: "center",
        }}
      >
        {!examMode && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Button
              onClick={handleClick}
              startIcon={
                showSummary ? (
                  <CloseRoundedIcon />
                ) : (
                  <FormatListBulletedRoundedIcon />
                )
              }
              size={isMobile() ? "large" : "medium"}
            >
              {Vocabulary.questionsSummary}
            </Button>

            <Button
              color="error"
              onClick={() => setOpenQuestionaryWarning(true)}
              startIcon={<RefreshIcon />}
              size={isMobile() ? "large" : "medium"}
            >
              {Vocabulary.reset}
            </Button>
          </div>
        )}
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "center",
            padding: isMobile() ? "0 1vw" : "0 100px",
          }}
        >
          {examMode && isMobile() && (
            <StatBox borderRight examMode fullWidth>
              <Countdown
                date={endTime} // 15 minutes from now
                renderer={renderer}
                onComplete={() => setIsFinished(true)}
              />
            </StatBox>
          )}
          <StatBox
            value={total}
            label="Întrebări inițiale"
            borderRight
            examMode
          />
          <StatBox
            value={remaining}
            label="Întrebări rămase"
            borderRight
            examMode
          />
          {examMode && !isMobile() && (
            <StatBox borderRight examMode>
              <Countdown
                date={endTime} // 15 minutes from now
                renderer={renderer}
                onComplete={() => setIsFinished(true)}
              />
            </StatBox>
          )}

          <StatBox
            value={correct}
            label="Răspunsuri corecte"
            color="green"
            borderRight
            examMode
          />
          <StatBox value={wrong} label="Răspunsuri greșite" color="red" />
        </Grid>
      </Paper>

      <GenericModal
        open={openQuestionaryWarning}
        onClose={() => {
          setOpenQuestionaryWarning(false);
        }}
        style={{ zIndex: 9999 }}
        title={Vocabulary.confirmDeleteTitle}
        actions={
          <StandardActionButtons
            okAction={() => handleQuestionaryReset()}
            cancelAction={() => setOpenQuestionaryWarning(false)}
            okText={Vocabulary.yes}
            cancelText={Vocabulary.no}
          />
        }
      >
        <div>{Vocabulary.resetQuestionaryWarning}</div>
      </GenericModal>
    </Box>
  );
}
